export enum IdentificationRequestStates {
	NEW,
	PENDING,
	SUCCESS,
	ERROR,
	RESPONDED,
	FAILED = 5
}
